import { ADDRESS_ZERO } from '~/constants/addresses'
import {
  getChain,
  STABLE_COINS_BY_CHAIN_ID_AND_ADDRESS,
  SupportedChainId,
} from '~/constants/chains'
import { IAddress } from '~/types'
import { EvmAddress } from '~/utils/address'
import { buildExplorerLink, ExplorerLinkType } from '~/utils/explorerLinks'

export const getExplorerAddressLinkChainId: (
  arg0: string | null | undefined,
  arg1: SupportedChainId | undefined,
) => string | undefined = (address, chainId) => {
  if (!address || !chainId) return

  return buildExplorerLink({
    chainId,
    type: ExplorerLinkType.ACCOUNT,
    address,
  })
}

export const getExplorerAddressLinkToken = (
  address: string | null | undefined,
  chainId: SupportedChainId | undefined,
  token: IAddress | undefined,
): string | undefined => {
  if (!address || !chainId || !token) return

  if (token === ADDRESS_ZERO) {
    return getExplorerAddressLinkChainId(address, chainId)
  }

  return buildExplorerLink({
    chainId,
    type: ExplorerLinkType.TOKEN,
    address,
    tokenAddress: token,
  })
}

export const getExplorerTransactionLinkChainId: (
  arg0: string | null | undefined,
  arg1: SupportedChainId | undefined,
) => string | undefined = (transactionId, chainId) => {
  if (!transactionId || !chainId) return

  return buildExplorerLink({
    chainId,
    type: ExplorerLinkType.TRANSACTION,
    txHash: transactionId,
  })
}

export const getExplorerUserOpLink = (
  userOpHash: string | null | undefined,
  chainId: SupportedChainId,
) => {
  if (!userOpHash || !chainId) return

  return buildExplorerLink({
    chainId,
    type: ExplorerLinkType.USER_OP,
    userOpHash,
  })
}

const shortenHash: (
  hash: string,
  startLength?: number,
  endLength?: number,
) => string = (hash, length = 6, endLength = 4) => {
  const start = hash.slice(0, length)
  const end = hash.slice(hash.length - endLength)
  return `${start}...${end}`
}

export const shortenAddress = shortenHash

export const getSupportedAddress = (
  address: string,
  chainId: SupportedChainId,
) => {
  if (!getChain(chainId)) {
    throw new Error(`Unsupported chain id: ${chainId}`)
  }

  return EvmAddress.format(address)
}

export const shortenENS: (arg0?: string) => string | undefined = (ens) => {
  return ens && ens.length > 25
    ? ens.substring(0, 11) + '...' + ens.substring(ens.length - 11)
    : ens
}

export const isStablecoin = (address: string, chainId: number) => {
  return !!STABLE_COINS_BY_CHAIN_ID_AND_ADDRESS[chainId]?.[
    EvmAddress.format(address)
  ]
}
